import React from 'react';
import { Star } from 'lucide-react';

interface Rating {
  id: number;
  fornecedor: string;
  rating: number;
  comentario: string;
  data: string;
}

interface RatingDisplayProps {
  ratings?: Rating[];
  rating?: number;
}

// Componente simples para exibir estrelas
export const StarRating: React.FC<{ rating: number }> = ({ rating }) => {
  return (
    <div className="flex space-x-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          className={`w-4 h-4 ${
            star <= rating
              ? 'text-yellow-400 fill-current'
              : 'text-gray-300'
          }`}
          fill={star <= rating ? 'currentColor' : 'none'}
        />
      ))}
    </div>
  );
};

const RatingDisplay: React.FC<RatingDisplayProps> = ({ ratings }) => {
  if (!ratings || ratings.length === 0) {
    return <div>Nenhuma avaliação disponível</div>;
  }
  
  const averageRating = ratings.reduce((acc, r) => acc + r.rating, 0) / ratings.length;

  return (
    <div className="space-y-6">
      {/* Summary */}
      <div className="card">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              Avaliação Média
            </h3>
            <div className="flex items-center space-x-2">
              <div className="flex space-x-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    className={`w-5 h-5 ${
                      star <= averageRating
                        ? 'text-yellow-400 fill-current'
                        : 'text-gray-300'
                    }`}
                    fill={star <= averageRating ? 'currentColor' : 'none'}
                  />
                ))}
              </div>
              <span className="text-lg font-semibold text-gray-900">
                {averageRating.toFixed(1)}
              </span>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-600">
              {ratings.length} {ratings.length === 1 ? 'avaliação' : 'avaliações'}
            </p>
          </div>
        </div>
      </div>

      {/* Individual Ratings */}
      <div className="space-y-4">
        {ratings.map((rating) => (
          <div key={rating.id} className="card">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <h4 className="font-semibold text-gray-900">
                    {rating.fornecedor}
                  </h4>
                  <div className="flex space-x-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star
                        key={star}
                        className={`w-4 h-4 ${
                          star <= rating.rating
                            ? 'text-yellow-400 fill-current'
                            : 'text-gray-300'
                        }`}
                        fill={star <= rating.rating ? 'currentColor' : 'none'}
                      />
                    ))}
                  </div>
                </div>
                {rating.comentario && (
                  <p className="text-gray-600 text-sm mb-2">
                    {rating.comentario}
                  </p>
                )}
                <p className="text-xs text-gray-500">
                  {new Date(rating.data).toLocaleDateString('pt-BR')}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RatingDisplay; 